// extracted by mini-css-extract-plugin
export default {"footer":"footer_footer__JylUk","linkText":"footer_linkText__A-yuA"};